/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationPaymentBillingInfoResponseData,
  GetOrganizationPaymentBillingInfoResponseDataFromJSON,
  GetOrganizationPaymentBillingInfoResponseDataFromJSONTyped,
  GetOrganizationPaymentBillingInfoResponseDataToJSON
} from './GetOrganizationPaymentBillingInfoResponseData'

/**
 *
 * @export
 * @interface GetOrganizationPaymentBillingInfoResponse
 */
export interface GetOrganizationPaymentBillingInfoResponse {
  /**
   *
   * @type {number}
   * @memberof GetOrganizationPaymentBillingInfoResponse
   */
  status: number
  /**
   *
   * @type {GetOrganizationPaymentBillingInfoResponseData}
   * @memberof GetOrganizationPaymentBillingInfoResponse
   */
  data: GetOrganizationPaymentBillingInfoResponseData
}

export function GetOrganizationPaymentBillingInfoResponseFromJSON(
  json: any
): GetOrganizationPaymentBillingInfoResponse {
  return GetOrganizationPaymentBillingInfoResponseFromJSONTyped(json, false)
}

export function GetOrganizationPaymentBillingInfoResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrganizationPaymentBillingInfoResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOrganizationPaymentBillingInfoResponseDataFromJSON(json['data'])
  }
}

export function GetOrganizationPaymentBillingInfoResponseToJSON(
  value?: GetOrganizationPaymentBillingInfoResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationPaymentBillingInfoResponseDataToJSON(value.data)
  }
}
